import ax from '../axios'
import {API_URL} from "../index";

const GRADE_LEVEL_URL = API_URL.EDUCATION_MODULE + '/grade-level'

const getGradeLevels = () => {
    return ax.get(`${GRADE_LEVEL_URL}`)
}

const getMaarifUnitFilter = (gradeLevelId: number, learningAreaId?: number) => {
    const query = learningAreaId ? `?learningAreaId=${learningAreaId}` : ''
    return ax.get(`${GRADE_LEVEL_URL}/${gradeLevelId}/maarif-unit-filter${query}`)
}
export {
    getGradeLevels,
    getMaarifUnitFilter,
}
